import { render, staticRenderFns } from "./TextAlign.vue?vue&type=template&id=48152c09"
import script from "./TextAlign.vue?vue&type=script&lang=js"
export * from "./TextAlign.vue?vue&type=script&lang=js"
import style0 from "./TextAlign.vue?vue&type=style&index=0&id=48152c09&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports